import request from '@/../../common/src/utils/requests/request';
import { ProductType } from '@/AppGlobal';
import { EddaBankInfo } from '@/interface/KKC/edda';

//
export const getList = (params: any) => request.post(``, params);

export const updateEddaBinding = (fillInItems: EddaBankInfo) =>
  request.post<{
    msgId: string;
  }>('credit/binding/update', fillInItems, { loading: true });

// 更新默认还款卡
export const updateCardbinding = (fillInItems: {
  msgId?: string | number;
  msgIdList?: {
    msgId: string;
    productCode: ProductType;
  }[];
}) => request.post('credit/binding/updateCard', fillInItems, { loading: true });
